module.exports = __webpack_public_path__ + "img/trash_delete.580ee165.svg";